module.exports = __webpack_public_path__ + "img/17846_L.530a720d.png";